import Tools from "./Tools"
import Parts from "./Parts"

const Preparations = ({ control, data, errors, pmtTypeId, toolList, setToolList, partslist, setPartslist }) => {

  return (
    <>
      <Tools
        control={control}
        data={data}
        errors={errors}
        pmtTypeId={pmtTypeId}
        list={toolList}
        setList={setToolList}
      />

      <Parts
        control={control}
        data={data}
        errors={errors}
        pmtTypeId={pmtTypeId}
        list={partslist}
        setList={setPartslist}
      />
    </>
  )
}
export default Preparations